import * as React from 'react'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import { utils, writeFile } from 'xlsx'
const PgXlsx: React.FC = () => {
    const handleClick = () => {
        const testData = [
            { 이름: '홍길동1', 나이: '18' },
            { 이름: '홍길동2', 나이: '19' },
            { 이름: '홍길동3', 나이: '20' },
            { 이름: '홍길동4', 나이: '21' },
            { 이름: '홍길동5', 나이: '22' },
        ]
        const sheet = utils.json_to_sheet(testData)
        const book = utils.book_new()
        utils.book_append_sheet(book, sheet, '임시시트')
        writeFile(book, '테스트.xlsx', { compression: true })
    }

    return (
        <>
            <p>xlsx 생성 테스트</p>
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="액셀 생성"
                onClick={handleClick}
            />
        </>
    )
}
export default PgXlsx
